import { Provider } from 'react-redux';
import { TuuiTheme } from 'tuui';
import { CustomRouter } from 'CustomRouter';
import history from 'services/history';
import { QueryProvider } from '../../services/query';
import { getStore } from '../../store';
import { ABTestProvider, abtEventEmitter } from '../taboola-common-frontend-modules/ab-test';
import { AppEventsProvider } from '../taboola-common-frontend-modules/app-events-aggregator/AppEventsProvider';
import { I18nProvider } from '../taboola-common-frontend-modules/i18n';
import { ModalProvider } from '../taboola-common-frontend-modules/modals';
import { QueryParamBatcherProvider, QueryParamsProvider } from '../taboola-common-frontend-modules/query-params';
import { useLogRocketInit } from './hooks/useLogRocketInit';
import { TAApiProvider } from './providers/TAApiProvider';
import { ConversionSetup } from './src/main/webapp/components/CodelessEvents/components/ConversionSetup';
import { FetchedConversionsProvider } from './src/main/webapp/contexts/FetchedConversionsContext';

export const CodelessEvents = () => {
    useLogRocketInit();

    return (
        <QueryProvider>
            <TAApiProvider>
                <Provider store={getStore()}>
                    <CustomRouter history={history}>
                        <QueryParamBatcherProvider>
                            <QueryParamsProvider>
                                <ABTestProvider eventEmitter={abtEventEmitter}>
                                    <TuuiTheme>
                                        <ModalProvider>
                                            <I18nProvider>
                                                <AppEventsProvider>
                                                    <FetchedConversionsProvider>
                                                        <ConversionSetup />
                                                    </FetchedConversionsProvider>
                                                </AppEventsProvider>
                                            </I18nProvider>
                                        </ModalProvider>
                                    </TuuiTheme>
                                </ABTestProvider>
                            </QueryParamsProvider>
                        </QueryParamBatcherProvider>
                    </CustomRouter>
                </Provider>
            </TAApiProvider>
        </QueryProvider>
    );
};
